import { Link } from "react-router";

import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import type { Id } from "@convex/_generated/dataModel";

export interface DeckReviewMessageProps {
  toReviewCount: number;
  deckId?: Id<"decks">;
}

export const DeckReviewMessage = ({ toReviewCount, deckId }: DeckReviewMessageProps) => {
  // TODO: these should be dynamic and based on some kind of algorithm about retention.
  const toReviewMinutes = Math.ceil(toReviewCount / 3);
  const retentionBoostDays = 5;

  const fromThisDeck = deckId ? "from this deck " : "";
  const toReviewMinutesMessage = toReviewMinutes > 1 ? `${toReviewMinutes} minutes` : "1 minute";
  const message =
    toReviewCount > 1 ? (
      <>
        You have <strong>{toReviewCount} cards</strong> {fromThisDeck}to review today. It should
        take about <strong>{toReviewMinutesMessage}</strong> and increase your average retention of
        these cards by <strong>{retentionBoostDays} days</strong>.
      </>
    ) : (
      <>
        You have <strong>1 card</strong> {fromThisDeck}to review today. It should take about{" "}
        <strong>{toReviewMinutesMessage}</strong> and increase your average retention of these cards
        by <strong>{retentionBoostDays} days</strong>.
      </>
    );
  return (
    <Card className="mb-6 bg-blue-50 border-blue-100">
      <CardContent>
        <h2 className="text-xl font-semibold mb-2">Today's Review</h2>
        <p className="mb-4">{message}</p>
        <Link to={deckId ? `/review/${deckId}` : "/review"}>
          <Button variant="secondary">
            {toReviewCount > 1 ? `REVIEW ${toReviewCount} CARDS` : "REVIEW CARD"}
          </Button>
        </Link>
      </CardContent>
    </Card>
  );
};
